import { useMutation } from '@tanstack/react-query';

import { SystemSettingCreateFormSchemaValues } from 'src/features/systems/utils/formSchema';
import { SystemSettings } from 'src/features/systems/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';
import { DisplaySettingCreateFormSchemaValues } from 'src/features/systems/utils/displaySettingFormSchema';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/system/setting/:id/`;

type MutationFnType = typeof mutationFn;

type DTO = (SystemSettingCreateFormSchemaValues | DisplaySettingCreateFormSchemaValues) & {
    id: string;
    parkingId: string;
};

const mutationFn = ({ id, parkingId, ...params }: DTO): Promise<SystemSettings> => {
    return axios.put(formatResourcePath(RESOURCE, { id, parkingId }), params);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateSystemSetting };
